// Upgrade Angularjs services to use it in Angular

export const versioningServiceProvider = {
  provide: 'VersioningService',
  useFactory: ($injector) => $injector.get('VersioningService'),
  deps: ['$injector'],
};

export const routeParamsProvider = {
  provide: '$routeParams',
  useFactory: ($injector) => $injector.get('$routeParams'),
  deps: ['$injector'],
};

export const locationProvider = {
  provide: '$location',
  useFactory: ($injector) => $injector.get('$location'),
  deps: ['$injector'],
};

export const amMomentProvider = {
  provide: 'amMoment',
  useFactory: ($injector) => $injector.get('amMoment'),
  deps: ['$injector'],
};

export const translateProvider = {
  provide: '$translate',
  useFactory: ($injector) => $injector.get('$translate'),
  deps: ['$injector'],
};

export const sessionServiceProvider = {
  provide: 'SessionService',
  useFactory: ($injector) => $injector.get('SessionService'),
  deps: ['$injector'],
};

export const productCategoryServiceProvider = {
  provide: 'ProductCategoryService',
  useFactory: ($injector) => $injector.get('ProductCategoryService'),
  deps: ['$injector'],
};

export const tourServiceProvider = {
  provide: 'TourService',
  useFactory: ($injector) => $injector.get('TourService'),
  deps: ['$injector'],
};

// export const locationServiceProvider = {
//   provide: 'LocationService',
//   useFactory: ($injector) => $injector.get('LocationService'),
//   deps: ['$injector'],
// };
